import { frontendURL } from 'dashboard/helper/URLHelper.js';

const meta = {
  permissions: ['administrator', 'agent'],
};

const unoficialCampaignsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/unoficial-campaigns'),
      name: 'unoficial_campaigns',
      meta: {
        ...meta,
      },
      redirect: to => {
        return { name: 'campaigns_unofficial_index', params: to.params };
      },
    },
  ],
};

export default unoficialCampaignsRoutes;
